import { html } from "@nodusjs/std/dom";

export const component = () => html`<button><slot></slot></button>`;
